import { Stack, Text } from '@fluentui/react';
import React from 'react';

interface ITimelineChartLegendItemProps {
    backgroundColor: string;
    label: string;
}

export const TimelineChartLegendItem: React.FC<ITimelineChartLegendItemProps> =
    (props: ITimelineChartLegendItemProps) => {
        return (
            <div className="TimelineChartLegendItem-root">
                <Stack
                    horizontal
                    tokens={{ childrenGap: 5 }}
                    style={{ alignItems: 'center' }}
                >
                    <div
                        style={{
                            width: 20,
                            height: 12,
                            backgroundColor: props.backgroundColor,
                            borderRadius: 2,
                        }}
                    />
                    <Text variant="small">{props.label}</Text>
                </Stack>
            </div>
        );
    };
